import { isNil } from './object';

let polyfillPerformance = self.performance;

if (isNil(polyfillPerformance)) {
  polyfillPerformance = {};
}

if ('now' in polyfillPerformance === false) {
  let nowOffset = Date.now();

  if (
    polyfillPerformance.timing &&
    polyfillPerformance.timing.navigationStart
  ) {
    nowOffset = polyfillPerformance.timing.navigationStart;
  }

  polyfillPerformance.now = function now() {
    return Date.now() - nowOffset;
  };
}

const performance = polyfillPerformance;
export default performance;
